<template>
  <div class="page">
    <div class="business">
      <div class="businessTitle">商务合作</div>
      <div class="businessEn">BECOME A SPONSOR</div>
    </div>
    <div class="businessContent">
        <div class="content-title">
          <div class="title">马欣</div>
          <div class="zhiwu">商务总监</div>
        </div>
        <div class="content-info">
          <img src="https://p0.ssl.qhimg.com/t110b9a93013917c8393828b74e.png" alt="">
          <div class="info" style="margin-left: 5px;margin-right: 26px;">15718876610</div>
          <img src="https://p5.ssl.qhimg.com/t110b9a9301cb12fc96c711b7f9.png" alt="">
          <div class="info" style="margin-left: 5px;">ISC@360.cn</div>
        </div>
    </div>
      <div class="business-list">
        <img class="business-item" style="width: 75px;" src="https://p4.ssl.qhimg.com/t110b9a9301bae345fa3c0bdde5.png" alt="">
        <img class="business-item" style="width: 75px;" src="https://p0.ssl.qhimg.com/t110b9a9301b172fea3a6531e33.png" alt="">
        <img class="business-item" style="width: 97px; margin-left: 0px;" src="https://p1.ssl.qhimg.com/t110b9a93013f3284c70fd0cdb5.png" alt="">
        <img class="business-item" style="width: 97px; margin-left: -20px;" src="https://p2.ssl.qhimg.com/t110b9a930115effc99f5f5ff70.png" alt="">
      </div>
      <div class="business-desc">
        <div class=desc>关注 @红衣大叔周鸿祎，解锁AI&安全最新知识</div>
      </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  margin-top: 60px;
  background: rgba(255, 255, 255, 1);
  padding: 45px 24px 55px;
  .business{
    width: 100%;
    display: flex;
    flex-direction: column;
    &Title{
      color: rgba(44, 44, 44, 1);
      font-family: Microsoft YaHei;
      font-size: 26px;
      font-weight: 600;
      line-height: 26px;
      letter-spacing: 0px;
    }
    &En{
      color: rgba(44, 44, 44, 1);
      font-family: Rubik;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0px;
      margin-top: 12px;
    }
  }
  .businessContent{
    width: 100%;
    display: flex;
    flex-direction: column;
    .content-title{
      display: flex;
      margin-top: 46px;
      align-items: flex-end;
      .title{
        color: rgba(44, 44, 44, 1);
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0px;
      }
      .zhiwu{
        color: rgba(44, 44, 44, 1);
        font-family: Microsoft YaHei;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0px;
        margin-left: 12px;
      }
    }
    .content-info{
      display: flex;
      align-items: center;
      margin-top: 16px;
      img{
        width: 20px;
        height: 20px;
      }
     .info{
        color: rgba(44, 44, 44, 1);
        font-family: Microsoft YaHei;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0px;
      }
    }
  }
  .business-list{
    width: 100%;
    display: flex;
    gap: 40px 95px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
  }
  .business-desc{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 12px;
    .desc{
      color: rgba(44, 44, 44, 1);
      font-family: HarmonyOS Sans SC;
      font-size: 13px;
      font-weight: 400;
      letter-spacing: 0px;
    }
  }
}
</style>
